import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const featureWarningMessage = ref<string | null>(null);
const featureWarningIgnoreLabel = ref<string>();

export function useFeatureWarning() {
  const { t } = useI18n();

  function setFeatureWarningMessage(warningMessage: string | null, ignoreLabel: string | null = null) {
    featureWarningIgnoreLabel.value = ignoreLabel
      ? ignoreLabel
      : t('panel.feature-limit-reached:modal:buttons:ignore-and-continue');

    featureWarningMessage.value = warningMessage;
  }

  return {
    setFeatureWarningMessage,
    featureWarningMessage,
    featureWarningIgnoreLabel,
  };
}
